import { IQuoteProps } from 'src/utilities/Interfaces'

export const sniderClickupQuote: IQuoteProps = {
  author: {
    name: 'Scott Snider',
    title: 'Lead Engineer'
  },
  body:
    'I was excited to leapfrog using Flatfile, rather than [having to] ' +
    'start from scratch on our own.',
  caseStudyPath: '/resources/case-studies/clickup',
  company: {
    jewelLogoSrc: '/img/quotes/clickup-jewel.webp',
    logoSrc: '/img/contentful/2a01EYal-clickup-white.svg',
    logoSrcBlack: '/img/logos/clickup-black.svg',
    logoSrcSvg: '/img/logos/clickup-black.svg',
    photoSrc: '/img/quotes/clickup-quote-photo.webp',
    name: 'ClickUp'
  }
}

export const gaiusParrotmobQuote: IQuoteProps = {
  author: {
    name: 'Osa Gaius',
    title: 'Founder'
  },
  body:
    'Flatfile has been a tremendous asset ' +
    'for us. Now I can work on features customers are asking for.',
  caseStudyPath: '/resources/case-studies/parrotmob',
  company: {
    jewelLogoSrc: '/img/quotes/parrotmob-jewel.webp',
    logoSrc: '/img/quotes/parrotmob.webp',
    name: 'ParrotMob'
  }
}

export const mayCustomscityQuote: IQuoteProps = {
  author: {
    name: 'James May',
    title: 'President'
  },
  body:
    'Flatfile is a key component of our platform and greatly ' +
    'improves our customer onboarding process.',
  caseStudyPath: '/resources/case-studies/customs-city',
  company: {
    jewelLogoSrc: '/img/quotes/customs-city-jewel.webp',
    logoSrc: '/img/quotes/customs-city.webp',
    logoSrcBlack: '/img/quotes/customs-city.webp',
    name: 'Customs City'
  }
}

export const outsetaQuote: IQuoteProps = {
  author: {
    name: 'Geoff Roberts',
    title: 'Co-founder'
  },
  body:
    'Literally crying tears of joy after onboarding a customer with ' +
    'Flatfile for the first time. How did someone not build this sooner?',
  caseStudyPath: '/resources/case-studies/outseta',
  company: {
    jewelLogoSrc: '',
    logoSrc: '/img/quotes/outseta-colored.webp',
    logoSrcBlack: '/img/quotes/outseta-colored.webp',
    name: 'Outseta'
  }
}

export const mimioQuote: IQuoteProps = {
  author: {
    name: 'Heath Cajandig',
    title: 'Vice President of Product'
  },
  body: 'We have always handled our data import internally. But this time, we needed to do it faster and with the assurance that it would be done without errors and securely.',
  caseStudyPath: '/resources/case-studies/mimeo/',
  company: {
    jewelLogoSrc: '',
    logoSrcBlack: '/img/quotes/mimeo-logo.svg',
    logoSrcSvg: '/img/quotes/mimeo-logo.svg',
    photoSrc: '/img/quotes/mimeo-office.webp',
    name: 'Mimeo'
  }
}

export const inkitQuote: IQuoteProps = {
  author: {
    name: 'Michael McCarthy',
    title: 'CEO'
  },
  body: 'It was really easy once we got it up and running and a huge time saver across the board. We stopped spending time on data import issues, and now see a 100 percent data import success rate. Flatfile exceeded our expectations.',
  caseStudyPath: '/resources/case-studies/inkit/',
  company: {
    jewelLogoSrc: '',
    logoSrc: '',
    logoSrcBlack: '/img/quotes/inkit-black.svg',
    logoSrcSvg: '/img/quotes/inkit-black.svg',
    photoSrc: '/img/quotes/inkit-img.webp',
    name: 'Inkit'
  }
}

export const flowQuote: IQuoteProps = {
  author: {
    name: 'Daniel Scrivner',
    title: 'CEO'
  },
  body: 'It creates an importing experience that handles the complexity behind the scenes and all the customer sees is a drop dead, simple user interface that makes the importing process easy for anyone on their team to handle.',
  caseStudyPath: '',
  company: {
    jewelLogoSrc: '',
    logoSrc: '',
    logoSrcBlack: '/img/quotes/flow.svg',
    logoSrcSvg: '/img/quotes/flow.svg',
    photoSrc: '/img/quotes/daniel-flow.webp',
    name: 'Flow'
  }
}

export const tableclothQuote: IQuoteProps = {
  author: {
    name: 'Kelly Abbott',
    title: 'Co-founder & CTO'
  },
  body: 'We cut the amount of time we spend wrangling with files by 95%. We basically had all hands working to solve those problems at times. The reduction in effort has saved us tens of thousands of dollars. Flatfile is a really good value for us.',
  caseStudyPath: '',
  company: {
    jewelLogoSrc: '',
    logoSrc: '/img/quotes/tablecloth.webp',
    logoSrcBlack: '/img/quotes/tablecloth-black.webp',
    logoSrcSvg: '',
    photoSrc: '/img/quotes/tablecloth-photo.webp',
    name: 'Tabelcloth'
  }
}

export const workdayQuote: IQuoteProps = {
  author: {
    name: 'Jonathan',
    title: 'Data Conversion Tooling Automation'
  },
  body: "Flatfile's platform sets a new bar for data-exchange solutions, offering unparalleled flexibility and capability in coding… it's an indispensable tool for any developer",
  caseStudyPath: '',
  company: {
    jewelLogoSrc: '',
    logoSrc: '/img/quotes/workday.svg',
    logoSrcBlack: '/img/quotes/workday.svg',
    logoSrcSvg: '',
    photoSrc: '/img/quotes/workday-photo.webp',
    name: 'Workday'
  }
}

export const buildopsQuote: IQuoteProps = {
  author: {
    name: 'Scott Patterson',
    title: 'Director of Implementation'
  },
  body: `It’s one of the more important tools in our implementation toolbox. Without tools like Flatfile, scaling would be almost impossible.`,
  caseStudyPath: '',
  company: {
    jewelLogoSrc: '',
    logoSrc: '/img/logos/png/buildops-white.png',
    logoSrcBlack: '/img/logos/png/buildops.webp',
    logoSrcSvg: '',
    photoSrc: '/img/quotes/workday-photo.webp',
    name: 'Workday'
  },
  callout: '20% decrease in customer activation time'
}
